export default __webpack_public_path__ + "static/media/fad.02a92ae3.png";